import h from 'hyperscript';

import saveIcon from '@disy/cadenza-icons/save.svg';
import { icon } from '@disy/lib/icon';

import { Modal } from 'ui/dialog/modal/modal';

import type { WorkbookId } from 'cadenza/repository/model/workbook-id.gen';
import { openWorkbookTestSuite } from 'cadenza/workbook/header/save-workbook-actions/open-workbook-test-suite-function';
import i18n from 'cadenza/workbook/header/save-workbook-actions/save-workbook-actions.properties';

import './publish-workbook-validation-dialog.css';

const COMPONENT_NAME = 'd-publish-workbook-validation-dialog';

export class PublishWorkbookValidationDialog extends Modal {
  _loadingMessageDialog;
  _publish;

  constructor({
    loadingMessageDialog,
    numberOfErrors,
    numberOfWarnings,
    workbookId,
    testSuiteResultId,
    savingAndPublishingProcess,
    publish,
  }: {
    loadingMessageDialog: Modal;
    numberOfErrors: number;
    numberOfWarnings: number;
    workbookId: WorkbookId;
    testSuiteResultId: string;
    savingAndPublishingProcess: boolean;
    publish: () => Promise<void>;
  }) {
    const errorsText = numberOfErrors === 1 ? 'singular' : 'plural';
    const warningsText = numberOfWarnings === 1 ? 'singular' : 'plural';
    const errorsAndWarningsText = `testing.errorsAndWarnings.description.${errorsText}.${warningsText}`;

    super({
      cancelButton: i18n('testing.cancel.title'),
      submitButton: i18n('testing.export.title'),
      title: 'WARNING',
      titleIcon: icon(saveIcon),
      content: () =>
        Promise.resolve(
          h('.d-stack-v.space-4', [
            h('div', [
              h('h1', i18n(errorsAndWarningsText, { errors: numberOfErrors, warnings: numberOfWarnings })),
              h('p', i18n('testing.warningMessage')),
              h('p', i18n('testing.showResults.description')),
              h('button.button', i18n('testing.showResults.title'), {
                onclick: (event: Event) => {
                  event.preventDefault();
                  // publishing the workbook, running the testsuite on the last version
                  openWorkbookTestSuite(workbookId, { testSuiteResultId });
                },
              }),
            ]),
            savingAndPublishingProcess ?
              h(
                '.d-alert.d-alert-success',
                h('strong', i18n('save-and-publish-workbook.success.saved.infoMessageAfterTesting')),
              )
            : null,
          ]),
        ),
    });

    this.classList.add(COMPONENT_NAME);

    this._loadingMessageDialog = loadingMessageDialog;
    this._publish = publish;

    this.addEventListener('cancel', () => loadingMessageDialog.closeAll());
  }

  protected override async onSubmit(event: SubmitEvent) {
    super.onSubmit(event);
    await this.setLoading(this._publish());
    this.closeAll();
    this._loadingMessageDialog.closeAll();
  }
}

customElements.define(COMPONENT_NAME, PublishWorkbookValidationDialog);
